import moment from 'moment';

export function parseMoment(date) {
  if (date === null || date === undefined)
    return date;
  if (moment.isMoment(date))
    return date;
  return moment.utc(date).local();
}
